import { render, staticRenderFns } from "./TasksHistory.vue?vue&type=template&id=7b65a9fe&scoped=true&"
import script from "./TasksHistory.vue?vue&type=script&lang=js&"
export * from "./TasksHistory.vue?vue&type=script&lang=js&"
import style0 from "./TasksHistory.vue?vue&type=style&index=0&id=7b65a9fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b65a9fe",
  null
  
)

export default component.exports